import { render, staticRenderFns } from "./schoolInfo.vue?vue&type=template&id=38d0a520&scoped=true"
import script from "./schoolInfo.vue?vue&type=script&lang=js"
export * from "./schoolInfo.vue?vue&type=script&lang=js"
import style0 from "./schoolInfo.vue?vue&type=style&index=0&id=38d0a520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0a520",
  null
  
)

export default component.exports